import React, { useState } from "react";
import { IGlossaryIconsBlockProps } from "../models/glossary-icons-block-models";
import GlossaryIcon from "./glossary-icon";
import GlossaryIconCategories from "./glossary-icon-categories";

const GlossaryIconsBlock = ({ glossaryIcons, sortDropdownLabel, groupByCategory }: IGlossaryIconsBlockProps) => {
    const [selectedSort, setSelectedSort] = useState('All');

    if (selectedSort == "A-Z") {
        glossaryIcons = glossaryIcons.sort((a, b) => a.iconName?.toLocaleLowerCase().localeCompare(b.iconName?.toLocaleLowerCase()));
    }
    if (selectedSort == "Z-A") {
        glossaryIcons = glossaryIcons.sort((a, b) => a.iconName?.toLocaleLowerCase().localeCompare(b.iconName?.toLocaleLowerCase()));
        glossaryIcons = glossaryIcons.reverse();
    }

    return (
        <div>
            {glossaryIcons.length > 1 &&
                <div className="glossary-block-filter">
                    <label htmlFor="sortSelect">{sortDropdownLabel}</label>
                    <select id="sortSelect" value={selectedSort} onChange={e => setSelectedSort(e.target.value)}>
                        <option key="All" value="All">All</option>
                        <option key="A-Z" value="A-Z">A-Z</option>
                        <option key="Z-A" value="Z-A">Z-A</option>
                    </select>
                </div>
            }

            {selectedSort == "All" && groupByCategory && <GlossaryIconCategories
                glossaryIcons={glossaryIcons}
            />}

            {(selectedSort == "A-Z" || selectedSort == "Z-A" || (selectedSort == "All" && !groupByCategory)) &&
                <div className="glossary-block-panel-container">
                    <h4 className="glossary-block-section-title">{selectedSort}</h4>
                    <div className="glossary-block-icon-list">
                        {glossaryIcons.map(icon =>
                            <GlossaryIcon glossaryIcon={icon} />
                        )}
                    </div>
                </div>
            }

        </div>
    )
}

export default GlossaryIconsBlock